module.exports = __webpack_public_path__ + "media/1x1/cy-9f04989a.svg";